module.exports = __webpack_public_path__ + "static/media/inactiveTickets.8174ee67.svg";